import AppID from '../../classes/AppID';
import { SpectrumAlertDialogProps } from '@adobe/react-spectrum';

import { PL_ALL_TOPICS_PS, PL_CREATION_FIELDS_PS } from './index';
import { DictionaryPhotoshopWeb } from './DictionaryPhotoshopWeb';
import { DictionaryExpress } from './DictionaryExpress';

import { PhotoshopDictionaries } from './PhotoshopDictionaries';
import { IllustratorDictionaries } from './IllustratorDictionaries';

import PreviewService from '../../services/PreviewService';
export const BACKEND_ERROR_MESSAGE = 'LCS SERVICE FAILURE';
export const UTUT_VERSION = '2.0.0';

export const TBW_CARD_TYPE_SECTION = 'SECTION';
export const TBW_CARD_TYPE_STARTER_FILE = 'STARTER_FILE';

export const CARD_ID_STARTER = 'CARD_ID_STARTER';
export const CARD_ID_INTRO = 'CARD_ID_INTRO';
export const CARD_ID_SECTION = 'CARD_ID_SECTION';
export const CARD_ID_SECTION1 = 'CARD_ID_SECTION1';
export const CARD_ID_FINISH = 'CARD_ID_FINISH';

export const TBW_CREATIVE_FIELDS_LABEL = 'lcp.constants.creativeFields';
export const TBW_TASKS_LABEL = 'lcp.constants.tasks';
export const TBW_TOPICS_LABEL = 'lcp.constants.topics';
export const TBW_TOOLS_LABEL = 'lcp.constants.toolsMenusPanels';
export const TBW_EXPERIENCE_LEVEL = 'lcp.constants.experienceLevel';
export const TBW_LEARNING_APPROACH = 'lcp.constants.learningApproach';
export const TBW_COMPLETE_MESSAGE = 'TBW_COMPLETE_MESSAGE';
export const TBW_THUMBNAIL = 'lcp.constants.tutorialThumbnail';
export const TBW_HEROIMAGE = 'lcp.constants.tutorialHeroImage';

export const TBW_INTRO_DROPDOWN = [
    { id: 'Tutorial thumbnail', name: 'lcp.constants.tutorialThumbnail' },
    { id: 'Tutorial hero image', name: 'lcp.constants.tutorialHeroImage' },
];

export const PL_CREATION_EXPERIENCE_LEVEL = [
    { id: 'beginner', name: 'lcp.constants.beginner' },
    { id: 'intermediate', name: 'lcp.constants.intermediate' },
    { id: 'intermediate-advanced', name: 'lcp.constants.advanced' },
];

export const TBW_LEARNING_APPROACH_DROPDOWN = [
    { id: 'edu-assignment', name: 'lcp.constants.learningApproach.eduAssignment' },
    { id: 'edu-lesson', name: 'lcp.constants.learningApproach.eduLesson' },
    { id: 'expert-bio', name: 'lcp.constants.learningApproach.expertBio' },
    { id: 'expert-course', name: 'lcp.constants.learningApproach.expertCourse' },
    { id: 'expert-template', name: 'lcp.constants.learningApproach.expertTemplate' },
    { id: 'guided-activity', name: 'lcp.constants.learningApproach.guidedActivity' },
    { id: 'guided-activity-edu-k12', name: 'lcp.constants.learningApproach.guidedActivity.eduk12' },
];

export const NEW_TUTORIAL_STATUS = 'dev';

export const TBW_NON_EN_TITLE_REGEX = new RegExp(/^[\p{L}\p{N}\p{M}’':!?.,\s_-]+$/u);

export const getFieldsList = (primaryProduct, fieldName) => {
    const totalList =
        fieldName === 'CREATIVE_FIELDS' ? PL_CREATION_FIELDS_PS : fieldName === 'TOPICS' ? PL_ALL_TOPICS_PS : [];
    let res: any = [];
    console.log('primaryProduct===>', primaryProduct);
    totalList.map((data) => {
        //console.log("data===>", data);
        const ele: any = { ...data };
        if (ele?.apps?.includes(primaryProduct)) {
            delete ele?.['apps'];
            //  console.log("ele===>", ele);
            res = [...res, ele];
        }
    });
    //console.log("res===>", res);
    return res;
};

export const getTutorialQuery = (ututLocale, ututStatus, ututApp) => {
    // double encoded as per mikeys request
    const encodedparams = encodeURIComponent(
        encodeURIComponent(`locale=${ututLocale}&status=${ututStatus}&appName=${ututApp}`),
    );
    return encodeURIComponent(`&lcs_params=${encodedparams}`);
};

export const getPSDorAIDInAppPreviewUrl = async (docId, locale, status, app) => {
    let previewUrl = '';
    const response = await new PreviewService().fetchDeeplinkUrl(docId, app, locale);
    if (!response?.failed) {
        const tutorialQuery = getTutorialQuery(locale, status, app);
        previewUrl = response?.data?.fullUrl;
        previewUrl = `${previewUrl}${tutorialQuery}`;
    }
    return previewUrl;
};

export const getPSWebInAppPreviewUrl = (docId, assertUrl, ututLocale, ututStatus, ututApp) => {
    console.log('docId,assertUrl===>', docId, assertUrl);
    const dp_query = encodeURIComponent(
        `content.type=cmWebHandsOnTutorial&content.id=${docId}&mode=hotPreview&preview=true`,
    );
    const dpasset = encodeURIComponent(assertUrl);

    const tutorialQuery = getTutorialQuery(ututLocale, ututStatus, ututApp);
    console.log('dp_query===>', dp_query);
    console.log('dpasset===>', dpasset);

    return `${process.env.PSW_PREVIEW_URL}dpasset=${dpasset}&dp_query=${dp_query}&locale=${ututLocale}&tutorial_query=${tutorialQuery}`;
};

export const getFileName = (url) => {
    console.log('URL==>', url);
    console.log('url.substring(url.lastIndexOf(/) + 1)==>', url.substring(url.lastIndexOf('/') + 1));
    return url ? url.substring(url.lastIndexOf('/') + 1) : '';
};

export const commandSuggestion = (surface: AppID, locale: string = 'en_US') => {
    switch (surface) {
        case AppID.PSWeb: {
            // let items = surface.isEqual(AppID.PSDesktop) ? DictionaryPhotoshop : DictionaryPhotoshopWeb
            // For now we remove duplicates and items that don't have "id", "label", or "placement"
            // items = items.filter((obj) =>
            //  obj.hasOwnProperty("id") && obj.hasOwnProperty("label") && obj.hasOwnProperty("placement")
            // );
            // let result = {};
            // items.map(el=>{ result[el.id!] = el });
            // items = Object.values(result);
            // console.log(items)
            return DictionaryPhotoshopWeb;
        }
        case AppID.PSDesktop: {
            // For now we remove duplicates and items that don't have "id", "label", or "placement"
            // Fallback to en_US if theres no dictionary for that locale yet
            return PhotoshopDictionaries[locale] ?? PhotoshopDictionaries['en_US'];
        }
        case AppID.Express: {
            return DictionaryExpress;
        }
        case AppID.Illustrator: {
            // For now we remove duplicates and items that don't have "id", "label", or "placement"
            // Fallback to en_US if theres no dictionary for that locale yet
            return IllustratorDictionaries[locale] ?? IllustratorDictionaries['en_US'];
        }
    }
};

export const taskInteractionPlacementOptions = [
    { id: 'Tool', label: 'Tool' },
    { id: 'MenuBar', label: 'Menu Bar' },
    { id: 'Panel', label: 'Panel' },
];

export const getStatusMapping = (uiStatus) => {
    return statusMapping[uiStatus] !== undefined ? statusMapping[uiStatus] : uiStatus;
};

export const statusMapping = {
    'In Progress': 'lcp.constants.roleLabels.inprogress',
    Submitted: 'lcp.constants.roleLabels.curation.ready',
    Published: 'lcp.constants.roleLabels.published',
    'Needs Review': 'lcp.constants.roleLabels.needs.edits',
    'Ready for Curator': 'lcp.constants.roleLabels.curation.ready',
    'Ready for QE': 'lcp.constants.roleLabels.qe.ready',
    'Ready for LOC': 'lcp.constants.roleLabels.loc.ready',
};

export const DIALOG_OPTIONS = {
    SEND_TO_CURATOR: 'send_to_curator',
    SEND_TO_CURATOR_SUCCESS: 'send_to_curator_success',
    SEND_TO_QE: 'send_to_qe',
    SEND_TO_QE_SUCCESS: 'send_to_qe_success',
    SEND_TO_QE_SUCCESS_DASHBOARD: 'send_to_qe_success_dashboard',
    RETURN_TO_AUTHOR: 'return_to_author',
    RETURN_TO_AUTHOR_SUCCESS: 'return_to_author_success',
    RETURN_TO_AUTHOR_SUCCESS_DASHBOARD: 'return_to_author_success_dashboard',
    APPROVE_BY_QE: 'approve_by_qe',
    APPROVE_BY_QE_SUCCESS: 'approve_by_qe_success',
    APPROVE_BY_QE_SUCCESS_DASHBOARD: 'approve_by_qe_success_dashboard',
    RETURN_TO_CURATOR: 'return_to_curator',
    RETURN_TO_CURATOR_SUCCESS: 'return_to_curator_success',
    RETURN_TO_CURATOR_SUCCESS_DASHBOARD: 'return_to_curator_success_dashboard',
    UNASSIGNED_ASSETS: 'unassigned_assets',
    REQUEST_FAILED: 'failed_request',
    SEND_TO_CURATOR_INCOMPLETE_FIELDS: 'send_to_curator_incomplete_fields',
    APPROVE_FOR_LOC: 'approve_for_loc',
    APPROVE_FOR_LOC_SUCCESS_DASHBOARD: 'approve_for_loc_success_dashboard',
    REFRESH_FOR_LOC: 'refresh_for_loc',
    REFRESH_FOR_LOC_SUCCESS_DASHBOARD: 'refresh_for_loc_success_dashboard',
    CREATE_NEW_VERSION: 'create_new_version',
};

interface TBWDialog {
    [key: string]: {
        title: string;
        content: string;
        confirm_button: string;
        cancel_button?: string;
        variant: SpectrumAlertDialogProps['variant'];
    };
}

export const DIALOG_MAPPING: TBWDialog = {
    [DIALOG_OPTIONS.SEND_TO_CURATOR]: {
        title: 'lcp.constants.tbw.dialog.sendToCurator.title',
        content: 'lcp.constants.tbw.dialog.sendToCurator.content',
        confirm_button: 'lcp.constants.tbw.dialog.sendToCurator',
        cancel_button: 'lcp.common.cancel',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.SEND_TO_CURATOR_SUCCESS]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.sentForCurationSuccess.content',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.SEND_TO_QE]: {
        title: 'lcp.constants.tbw.dialog.sendToQE.title',
        content: 'lcp.constants.tbw.dialog.sendToQE.content',
        confirm_button: 'lcp.constants.tbw.dialog.sendToQE',
        cancel_button: 'lcp.common.cancel',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.SEND_TO_QE_SUCCESS]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.sendToQE.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.SEND_TO_QE_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.sendToQE.success.dashboard',
        confirm_button: 'lcp.common.close',
        cancel_button: undefined,
        variant: 'information',
    },
    [DIALOG_OPTIONS.RETURN_TO_AUTHOR]: {
        title: 'lcp.constants.tbw.dialog.returnToAuthor.title',
        content: 'lcp.constants.tbw.dialog.returnToAuthor.content',
        confirm_button: 'lcp.constants.tbw.dialog.returnToAuthor',
        cancel_button: 'lcp.common.cancel',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.RETURN_TO_AUTHOR_SUCCESS]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.returnToAuthor.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.RETURN_TO_AUTHOR_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.returnToAuthor.success',
        confirm_button: 'lcp.common.close',
        cancel_button: undefined,
        variant: 'information',
    },
    [DIALOG_OPTIONS.APPROVE_BY_QE]: {
        title: 'lcp.constants.tbw.dialog.approveByQE.title',
        content: 'lcp.constants.tbw.dialog.approveByQE.content',
        cancel_button: 'lcp.common.cancel',
        confirm_button: 'lcp.constants.tbw.dialog.approveByQE',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.APPROVE_BY_QE_SUCCESS]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.approveByQE.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.APPROVE_BY_QE_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.approveByQE.success',
        confirm_button: 'lcp.common.close',
        cancel_button: undefined,
        variant: 'information',
    },
    [DIALOG_OPTIONS.RETURN_TO_CURATOR]: {
        title: 'lcp.constants.tbw.dialog.returnToCurator.title',
        content: 'lcp.constants.tbw.dialog.returnToCurator.content',
        confirm_button: 'lcp.constants.tbw.dialog.returnToCurator',
        cancel_button: 'lcp.common.cancel',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.RETURN_TO_CURATOR_SUCCESS]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.returnToCurator.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.RETURN_TO_CURATOR_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.returnToCurator.success',
        confirm_button: 'lcp.common.close',
        cancel_button: undefined,
        variant: 'information',
    },
    [DIALOG_OPTIONS.UNASSIGNED_ASSETS]: {
        title: 'lcp.constants.tbw.dialog.unassignedAssets.title',
        content: 'lcp.constants.tbw.dialog.unassignedAssets.content',
        confirm_button: 'lcp.common.ok',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.REQUEST_FAILED]: {
        title: 'lcp.constants.tbw.dialog.requestFailed.title',
        content: 'lcp.constants.tbw.dialog.requestFailed.content',
        confirm_button: 'lcp.common.close',
        cancel_button: undefined,
        variant: 'error',
    },
    [DIALOG_OPTIONS.SEND_TO_CURATOR_INCOMPLETE_FIELDS]: {
        title: 'lcp.constants.tbw.dialog.incompleteFields.title',
        content: 'lcp.constants.tbw.dialog.incompleteFields.content',
        confirm_button: 'lcp.common.ok',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.APPROVE_FOR_LOC]: {
        title: 'lcp.constants.tbw.dialog.approveByLocQE.title',
        content: 'lcp.constants.tbw.dialog.approveByLocQE.content',
        cancel_button: 'lcp.common.cancel',
        confirm_button: 'lcp.constants.tb.action.locqe.approve',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.APPROVE_FOR_LOC_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.approveByLocQE.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.REFRESH_FOR_LOC]: {
        title: 'lcp.constants.tbw.dialog.refreshForLoc.title',
        content: 'lcp.constants.tbw.dialog.refreshForLoc.content',
        cancel_button: 'lcp.common.cancel',
        confirm_button: 'lcp.common.refresh',
        variant: 'destructive',
    },
    [DIALOG_OPTIONS.REFRESH_FOR_LOC_SUCCESS_DASHBOARD]: {
        title: 'lcp.constants.tbw.dialog.success.confirm',
        content: 'lcp.constants.tbw.dialog.refreshForLoc.success',
        confirm_button: 'lcp.constants.tbw.dialog.returnToHome',
        cancel_button: undefined,
        variant: 'confirmation',
    },
    [DIALOG_OPTIONS.CREATE_NEW_VERSION]: {
        title: 'lcp.constants.tbw.dialog.newVersion.title',
        content: 'lcp.constants.tbw.dialog.newVersion.content',
        cancel_button: 'lcp.common.cancel',
        confirm_button: 'lcp.common.action.create',
        variant: 'destructive',
    },
};
